/* PROTOCOL flow v6
   Loaded by all three CHT flows. Additive only: it does not replace any
   existing behaviour, it layers on top after the snippet has booted.
   Base snippets (protocol-style-2.liquid, protocol-addons-style.liquid) unchanged. */
(function(){
  'use strict';

  /* ---------- 1. gate removal (join-protocol only) ----------
     Flows 2 and 3 already open on add-ons, so this is a no-op there. */
  function killGate(){
    var p0 = document.getElementById('panel-0');
    var form = document.getElementById('form-block');
    if(!p0 || !form) return false;                 /* add-ons / renew: nothing to do */
    if(typeof window.goStep !== 'function') return false;
    if(window.current === 0){ window.goStep(1); }  /* land on add-ons, never the form */
    p0.remove();
    form.remove();
    return true;
  }

  /* ---------- 2. Cystatin C age ranking ----------
     Kidney relevance rises with age, but the marker was in no age list, so
     selecting 35-49 or 50+ pushed it to last of 15. */
  function fixAges(){
    if(typeof window.MB_AGE_NAMES !== 'object' || !window.MB_AGE_NAMES) return;
    ['35-49','50+'].forEach(function(band){
      var list = window.MB_AGE_NAMES[band];
      if(list && list.indexOf('Cystatin C') === -1) list.push('Cystatin C');
    });
  }

  /* ---------- 3. coverage bullets ---------- */
  /* 27 Sep 2026: vaccines and sexual health had no area and fell through to
     "Organs". Each new area is listed only when its category exists in the
     flow, so employer flows (join-visa, join-dsg) never show Sexual health. */
  var AREAS=[['heart','Heart & vascular'],['horm','Hormones'],['thy','Thyroid & immune'],
             ['nutr','Nutrients'],['gut','Gut'],['cancer','Cancer screening'],
             ['body','Body composition'],['organs','Organs'],['gene','Inherited risk'],
             ['vax','Vaccines','vaccination'],['sexual','Sexual health','sexual-health']];
  function areasHere(){
    return AREAS.filter(function(a){ return !a[2] || (typeof CATALOGUE==='object' && CATALOGUE && CATALOGUE[a[2]]); });
  }
  var SUB={'Heart':'heart','Heart & vascular':'heart','Hormones & Adrenal':'horm',
           'Thyroid & Immune':'thy','Nutrients & Vitamins':'nutr','Cancer screening':'cancer',
           'Blood & swab':'cancer','Body composition & longevity':'body',
           'Lungs & chest':'organs','Metabolic & liver':'organs'};
  function areaFor(name){
    if(typeof CATALOGUE !== 'object') return null;
    for(var c in CATALOGUE){
      var gs=CATALOGUE[c].groups;
      for(var i=0;i<gs.length;i++){
        for(var j=0;j<gs[i].items.length;j++){
          if(gs[i].items[j].name===name){
            if(c==='gut') return 'gut';
            if(c==='genetics') return 'gene';
            if(c==='vaccination') return 'vax';
            if(c==='sexual-health') return 'sexual';
            return SUB[gs[i].items[j].sub] || 'organs';
          }
        }
      }
    }
    return null;
  }
  function buildCoverage(){
    if(document.getElementById('pv6-cov')) return;
    var total=document.getElementById('total'); if(!total) return;
    var row=total.closest('.total-row'); if(!row) return;
    var d=document.createElement('div'); d.id='pv6-cov';
    var LIST=areasHere();
    d.innerHTML='<div class="pv6-covhd"><span>Add-ons cover</span><b id="pv6-covn">0 of '+LIST.length+' areas</b></div>'+
      '<ul id="pv6-covlist">'+LIST.map(function(a){return '<li data-k="'+a[0]+'"><i></i>'+a[1]+'</li>';}).join('')+'</ul>';
    row.parentNode.insertBefore(d,row);
  }
  var seenLit={};
  function updateCoverage(){
    var lit={}, c=window.cart||{};
    Object.keys(c).forEach(function(k){ var a=areaFor(k); if(a) lit[a]=1; });
    var n=0;
    document.querySelectorAll('#pv6-covlist li').forEach(function(li){
      var on=!!lit[li.dataset.k];
      li.classList.toggle('lit',on);
      if(on){
        n++;
        if(!seenLit[li.dataset.k]){
          var i=li.querySelector('i');
          i.classList.remove('pop'); void i.offsetWidth; i.classList.add('pop');
          setTimeout(function(){ i.classList.remove('pop'); },400);
        }
      }
      seenLit[li.dataset.k]=on;
    });
    var el=document.getElementById('pv6-covn');
    if(el) el.textContent=n+' of '+document.querySelectorAll('#pv6-covlist li').length+' areas';
  }

  /* ---------- 4. trust line + GST ----------
     Prices are shown before GST and 9% is added at checkout, so $649 becomes
     $707.41. That was stated nowhere in the flow. */
  var LOCK='<svg width="11" height="13" viewBox="0 0 12 14" fill="none" aria-hidden="true">'+
    '<rect x="1.1" y="5.9" width="9.8" height="7.2" rx="2" stroke="currentColor" stroke-width="1.15"/>'+
    '<path d="M3.6 5.9V4.05a2.4 2.4 0 0 1 4.8 0V5.9" stroke="currentColor" stroke-width="1.15" stroke-linecap="round"/></svg>';
  function trustLine(){
    var t=document.querySelector('#continue-block .trust');
    if(t && t.dataset.pv6!=='1'){
      t.innerHTML='<span class="pv6-t1">'+LOCK+'Secure checkout \u00b7 Cancel anytime</span>'+
                  '<span class="pv6-t2">Prices exclude GST</span>';
      t.dataset.pv6='1';
    }
    var ml=document.querySelector('#mbar .ml');
    if(ml && !ml.querySelector('.pv6-gst')){
      var s=document.createElement('span'); s.className='pv6-gst'; s.textContent=' excl. GST';
      ml.appendChild(s);
    }
  }

  /* ---------- 5. Core Health Test details modal ---------- */
  var CH=[['Body & vitals','#A39A8F',12,'Body composition, muscle mass, visceral fat, BMI, blood pressure'],
          ['Heart & metabolic','#F39C6B',13,'Cholesterol, ApoB, ApoB/A1, triglycerides, glucose, HbA1c, hs-CRP'],
          ['Hormones','#C28C94',16,'Testosterone, estradiol, progesterone, LH, FSH, SHBG, prolactin, thyroid'],
          ['Organs & blood','#6FAF90',36,'Liver, kidneys, full blood count, urine and stool chemistry'],
          ['Nutrients','#FFD166',10,'Vitamin D, B12, folate, ferritin, iron studies, calcium'],
          ['Cancer markers','#949ED4',4,'PSA, CA 125, CA 15.3, CEA']];
  function buildModal(){
    if(document.getElementById('pv6-scrim')) return;
    var sc=document.createElement('div'); sc.id='pv6-scrim';
    sc.innerHTML='<div id="pv6-modal"><button class="pv6-x" aria-label="Close">\u00d7</button>'+
      '<div class="pv6-top"><div class="pv6-eyebrow">Already in your order</div>'+
      '<div class="pv6-big"><b>100+</b><span>biomarkers, one blood draw</span></div>'+
      '<p class="pv6-sub">Your Core Health Test reads every major system. Here is the shape of the panel.</p>'+
      '<div class="pv6-bar">'+CH.map(function(c,i){
        return '<i style="background:'+c[1]+';flex:'+c[2]+';animation-delay:'+(120+i*70)+'ms"></i>';}).join('')+'</div></div>'+
      '<div class="pv6-body">'+CH.map(function(c,i){
        return '<div class="pv6-ch" style="animation-delay:'+(260+i*55)+'ms"><span class="pv6-sw" style="background:'+c[1]+'"></span>'+
          '<div><div class="pv6-h"><b>'+c[0]+'</b><em>'+c[2]+'</em></div><div class="pv6-list">'+c[3]+'</div></div></div>';}).join('')+
      '<div class="pv6-inc"><h4>Also included</h4>'+
      '<div><i>\u2713</i><span>A doctor consult to walk through every result</span></div>'+
      '<div><i>\u2713</i><span>A free retest at six months to see what moved</span></div>'+
      '<div><i>\u2713</i><span>Lifetime tracking in your dashboard</span></div></div>'+
      '<div class="pv6-foot"><button class="pv6-close">Close</button></div></div></div>';
    document.body.appendChild(sc);
    function close(){ sc.classList.remove('on'); }
    sc.addEventListener('click',function(e){ if(e.target===sc) close(); });
    sc.querySelector('.pv6-x').addEventListener('click',close);
    sc.querySelector('.pv6-close').addEventListener('click',close);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
  }
  function addDetailsLink(){
    var row=document.querySelector('#rail .prod-row'); if(!row) return;
    if(row.querySelector('.pv6-more')) return;
    var host=row.querySelector('.desc'); if(!host) return;
    var a=document.createElement('span'); a.className='pv6-more'; a.textContent="What's included";
    a.addEventListener('click',function(){ buildModal(); document.getElementById('pv6-scrim').classList.add('on'); });
    host.parentNode.appendChild(a);
  }

  /* ---------- 6. mobile summary as a bottom sheet ---------- */
  var back=null;
  function sheet(){
    var rail=document.getElementById('rail'); if(!rail) return;
    if(!back){
      back=document.createElement('div'); back.id='pv6-backdrop';
      back.addEventListener('click',function(){ if(typeof window.toggleRail==='function') window.toggleRail(); });
      document.body.appendChild(back);
    }
    var m=document.getElementById('mbar');
    if(m){ document.documentElement.style.setProperty('--pv6-mbarh',(Math.round(m.getBoundingClientRect().height)||71)+'px'); }
    var open = window.matchMedia('(max-width:880px)').matches &&
               rail.classList.contains('collapsible') && rail.classList.contains('open');
    back.classList.toggle('on',open);
    document.body.classList.toggle('pv6-sheet-open',open);
  }

  /* ---------- 7. landing motion ---------- */
  function chipsIn(){
    var mb=document.getElementById('matchbar'); if(!mb) return;
    mb.classList.remove('pv6-anim'); void mb.offsetWidth; mb.classList.add('pv6-anim');
    mb.querySelectorAll('.mb-chip').forEach(function(c,i){ c.style.animationDelay=(40+i*26)+'ms'; });
  }
  function dotsSweep(){
    document.querySelectorAll('#pv6-covlist li i').forEach(function(d,i){
      d.classList.remove('sweep'); void d.offsetWidth;
      d.style.animationDelay=(120+i*55)+'ms'; d.classList.add('sweep');
      setTimeout(function(){ d.classList.remove('sweep'); d.style.animationDelay=''; },120+i*55+600);
    });
  }

  /* ---------- wiring ----------
     `wrap()` used to call the original function with no try/catch. On
     add-ons/renew, the theme's own configureRail() throws a pre-existing
     null reference in protocol-addons-style.liquid, unrelated to v6, and
     with no guard here that exception propagated out of our wrapper and
     stopped the rest of v6's boot from running. Wrapping the original
     call restores the isolation the rest of this file already assumes. */
  var savedSeen=false;
  function afterSync(){
    buildCoverage(); updateCoverage(); trustLine(); addDetailsLink();
    var sr=document.getElementById('savings-row');
    if(sr && getComputedStyle(sr).display!=='none'){
      if(!savedSeen){ sr.classList.add('pv6-in'); savedSeen=true;
        setTimeout(function(){ sr.classList.remove('pv6-in'); },400); }
    } else { savedSeen=false; }
  }
  function wrap(name,after){
    if(typeof window[name]!=='function') return false;
    var orig=window[name];
    window[name]=function(){
      var r;
      try{ r=orig.apply(this,arguments); }
      catch(e){ /* a pre-existing theme fault must not stop v6 code from running */ }
      try{ after(); }catch(e){}
      return r;
    };
    return true;
  }

  function boot(){
    if(typeof window.syncSummary!=='function'){ setTimeout(boot,200); return; }
    fixAges();
    killGate();
    wrap('syncSummary',function(){ setTimeout(afterSync,20); });
    wrap('configureRail',function(){ trustLine(); });
    var rail=document.getElementById('rail');
    if(rail) new MutationObserver(sheet).observe(rail,{attributes:true,attributeFilter:['class']});
    window.addEventListener('resize',sheet);
    afterSync(); sheet();
    if(typeof window.renderCatalogue==='function'){ try{ window.renderCatalogue(); }catch(e){} }
    setTimeout(function(){ chipsIn(); setTimeout(dotsSweep,260); },420);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setTimeout(boot,400); });
  else setTimeout(boot,400);
})();
